import IndexPage from '../../views/users/Index.vue'

import multiguard from 'vue-router-multiguard'
import { auth, isAdmin } from '../middlewares'

export default [
  {
    path: '/users',
    component: IndexPage,
    name: 'users.index',
    beforeEnter: multiguard([auth, isAdmin])
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/users.js